/**
 * Font weight definitions used throughout the Ardoq design system.
 *
 * @internal These tokens should only be used within the design system.
 * Use the typography components or mixins from `@ardoq/typography` instead.
 */
export const fontWeight = {
  regular: 400,
  semibold: 500,
  bold: 600,
};
